<template>
  <BasicLayout v-slot:default="slotProps">
    <div class="checkout-process-wrap">
      <CheckoutProcess
        :current-order-step="currentOrderStep"
        :editable="!isFirstOrLast"
        @editData="editStep('1')"
        @editWarranty="editStep('2a')"
        @editFridayWarranty="editStep('2b')"
        @editFinancing="editStep('3')"
        @editApproval="editStep('4a')"
        @editDelivery="editStep('4b')"
        @editContact="editStep('5')"
        @goToSummary="editStep('6')"
      />
    </div>
    <div class="page order-create">
      <div class="page__content">
        <FirstCombinedStep
          v-if="(step1 || step1Substep) && slotProps.car"
          :is-substep="step1Substep"
          :current-order-step="currentOrderStep"
          :car="slotProps.car"
          :order="order"
          :start-order-process="startOrderProcess"
          :update-order-step="updateOrderStep"
          :order-creation-error="orderCreationError"
          :order-creation-error-details="orderCreationErrorDetails"
          :edit-mode="editMode"
        />
        <SecondCombinedStep 
          v-if="(step2 || step2Substep) && order"
          :is-substep="step2Substep"
          :order="order"
          :update-order-step="updateOrderStep"
          :edit-mode="editMode"
        />
        <FinancedPlanForm
          v-if="step3 && order"
          :order="order"
          @updateOrderStep="(token, params) => updateFinancingStep(token, params, '4a')"
          :edit-mode="editMode"
        />
        <ApprovalPkwForm
          v-if="step4 && order"
          :order="order"
          @updateOrderStep="(token, params) => updateOrderStep(token, params, '4b')"
          :edit-mode="editMode"
        />
        <DeliveryForm
          v-if="step4Substep && order"
          :order="order"
          @updateOrderStep="(token, params) => updateOrderStep(token, params, '5')"
          @editData="editStep('2a')"
          :edit-mode="editMode"
        />
        <ContactPreferences
          v-if="step5 && order"
          :order="order"
          @updateOrderStep="(token, params) => updateOrderStep(token, params, '6')"
          :edit-mode="editMode"
        />
        <Summary
          v-if="step6 && order"
          :order="order"
          :financing-edited="financingEdited"
          @editData="editStep('1')"
          @editWarranty="editStep('2a')"
          @editFridayWarranty="editStep('2b')"
          @editFinancing="editStep('3')"
          @editApproval="editStep('4a')"
          @editDelivery="editStep('4b')"
          @editContact="editStep('5')"
          @finalizeOrderCreate="finalizeOrder"
        />
        <ThankYouContent
          v-if="step7 && order && slotProps.car"
          :number="order.number"
          :phone="order.phone"
          :token="order.token"
          :payment-method="order.payment_method"
          :user-name="`${order.name} ${order.surname}`"
          :car-id="slotProps.car.id"
          :car-details="slotProps.car"
          :contact-preferences="order.only_available_online"
          @editFridayWarranty="editStep('2b')"
        />
      </div>
      <CarDetails
        v-if="slotProps.car"
        :current-order-step="currentOrderStep"
        :car="slotProps.car"
        :order="order"
        :show-finish-btn="step6"
        :edit-mode="editMode"
        :financing-edited="financingEdited"
        @finalizeOrderCreate="finalizeOrder"
        @editData="editStep('1')"
        @editWarranty="editStep('2a')"
        @editFridayWarranty="editStep('2b')"
        @editFinancing="editStep('3')"
        @editApproval="editStep('4a')"
        @editDelivery="editStep('4b')"
        @editContact="editStep('5')"
        @goToSummary="editStep('6')"
      />
    </div>
  </BasicLayout>
</template>

<script>
import Cookie from 'js-cookie';

import { createOrder, updateOrder, finalizeOrderCreate } from '@/api/checkout';
import BasicLayout from '../components/layout/BasicLayout';
import FirstCombinedStep from "@/components/FirstCombinedStep";
import SecondCombinedStep from "@/components/SecondCombinedStep";
import BankEmailForm from '../components/BankEmailForm';
import OrderDataForm from '../components/OrderDataForm';
import ApprovalPkwForm from '../components/ApprovalPkwForm';
import DeliveryForm from '../components/DeliveryForm';
import FinancedPlanForm from '../components/FinancedPlanForm';
import ContactPreferences from '../components/ContactPreferences';
import Warranty from '../components/Warranty';
import Summary from '../components/Summary';
import ThankYouContent from '../components/ThankYouContent';
import CheckoutProcess from '../components/CheckoutProcess';
import CarDetails from '../components/CarDetails';
import { STANDARD, SELF } from '../components/ApprovalPkwForm.vue';

export const cookieOpts = { path: '/', domain: '.pkw.de' };

export default {
  components: {
    CheckoutProcess,
    BankEmailForm,
    BasicLayout,
    CarDetails,
    DeliveryForm,
    FirstCombinedStep,
    SecondCombinedStep,
    OrderDataForm,
    ApprovalPkwForm,
    FinancedPlanForm,
    Summary,
    ThankYouContent,
    ContactPreferences,
    Warranty,
  },
  data() {
    return {
      currentOrderStep: this.$route.query.step || '0',
      order: sessionStorage.getItem('order') ? JSON.parse(sessionStorage.getItem('order')) : null,
      orderCreationError: null,
      orderCreationErrorDetails: null,
      financingEdited: false,
      editMode: false,
      STANDARD, SELF,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 520;
    },
    step1() {
      return this.currentOrderStep === '0';
    },
    step1Substep() {
      return this.currentOrderStep === '1';
    },
    step2() {
      return this.currentOrderStep === '2a';
    },
    step2Substep() {
      return this.currentOrderStep === '2b';
    },
    step3() {
      return this.currentOrderStep === '3';
    },
    step4() {
      return this.currentOrderStep === '4a';
    },
    
    step4Substep() {
      return this.currentOrderStep === '4b';
    },
    
    step5() {
      return this.currentOrderStep === '5';
    },
    step6() {
      return this.currentOrderStep === '6';
    },
    step7() {
      return this.currentOrderStep === '7';
    },
    isFirstOrLast() {
      return this.step1 || this.step7;
    },
    statisticSteps() {
      return {
        '0': '0',
        '1': '1',
        '2a': '2a',
        '2b': '2b',
        '3': '3',
        '4a': '4a',
        '4b': '4b',
        '5': '5',
        '6': '6',
        '7': '7',
      };
    },
  },
  watch: {
    $route(to, from) {
      if (!to.query.step) {
        this.saveStepData(null, '0');
      } else if (from.query.step === '7' && this.order && this.order.status !== 'draft') {
        this.saveStepData(null, '0');
      } else if (!from.query.step && !this.order) {
        this.saveStepData(null, '0');
      } else {
        this.saveStepData(this.order, to.query.step || '0');
      }
    },
    currentOrderStep(value) {
      if (value === '7') {
        window.gtag('event', 'conversion', {
          send_to: 'AW-462031264/k1FECKuExfABEKCTqNwB',
          transaction_id: '',
        });
      }
    },
  },
  mounted() {
    const sessionStep = sessionStorage.getItem('currentOrderStep');
    const sessionOrder = sessionStorage.getItem('order');
    const routeStep = this.$route.query.step;
    
    if (routeStep && (!sessionOrder || sessionOrder === 'null')) {
      this.saveStepData(null, '0');
    } else if (routeStep && routeStep > sessionStep) {
      this.saveStepData(this.order, sessionStep);
    } else {
      this.sendStatisticEvent(this.statisticSteps[this.currentOrderStep]);
    }
  },
  methods: {
    startOrderProcess(params) {
      createOrder(params).then(r => {
        this.order = r;
        this.sendStatisticEvent('1');
        this.saveStepData(r, '1');
        this.scrollToTop();
      }).catch(e => {
        this.orderCreationError = e.error;
        if (e.details) {
          this.orderCreationErrorDetails = e.details
        }
        Cookie.set('pendingCarId', this.$route.query.carId, cookieOpts);
      });
    },
    updateOrderStep(token, params, stepNumber) {
      updateOrder(token, params).then(r => {
        this.order = r;
        const storageStep = sessionStorage.getItem('currentOrderStep');
        const step = stepNumber < storageStep ? storageStep : stepNumber;
        this.sendStatisticEvent(this.statisticSteps[step]);
        this.saveStepData(r, step);
        this.scrollToTop();
      });
    },
    updateFinancingStep(token, params, stepNumber) {
      if (this.editMode && params.payment_method === 'financing' && this.order.registration_service === SELF) {
        this.financingEdited = true;
        const newParams = { ...params, registration_service: STANDARD };
        this.updateOrderStep(token, newParams, stepNumber);
      } else {
        this.updateOrderStep(token, params, stepNumber);
      }
    },
    sendStatisticEvent(step) {
      console.log('statistic event step number', step);
      window.dataLayer.push({
        event: 'order_step',
        step_number: step,
      });
    },
    editStep(num) {
      if (this.$route.query.step >= num) {
        this.financingEdited = false;
        this.editMode = true;
        this.sendStatisticEvent(this.statisticSteps[num]);
        this.changeStep(num);
        this.scrollToTop();
      }
    },
    changeStep(num) {
      this.currentOrderStep = num;
    },
    saveStepData(data, stepNumber) {
      this.order = data;
      this.editMode = false;
      this.changeStep(stepNumber);

      sessionStorage.setItem('currentOrderStep', stepNumber);
      sessionStorage.setItem('order', JSON.stringify(data));

      this.updateRoute(data, stepNumber);
    },
    updateRoute(data, stepNumber) {
      const query = { ...this.$route.query };
      if (stepNumber === '0') {
        delete query.step;
        this.$router.push({ name: '1', query }).catch(() => {});
      } else if (stepNumber !== this.$route.query.step) {
        this.$router.push({ name: '1', query: { ...query, step: stepNumber } });
      }
    },
    sendFinalStatistic(order) {
      let pushObject = {
        event: 'purchase',
        transactionId: order.number,
        transactionAffiliation: '',
        transactionTotal: order.car_info.price.customer,
        transactionTax: 0.0,
        transactionShipping: 0.0,
        transactionProducts: [
          {
            sku: order.car_info.id,
            name: order.headline,
            category: order.car_info.bodytype.name,
            price: order.car_info.price.customer,
            quantity: 1,
            content_type: "vehicle",
            currency: "EUR",
            availability: true,
            body_style: this.mapBodytype(order.car_info.bodytype.name), // this needs to be normalized
            postal_code: order.car_info.owner.zip,
            country: order.car_info.owner.country,
            dealer_name: order.car_info.owner.name,
            fuel_type: this.mapFueltype(order.car_info.fueltype.name), // this needs to be normalized
            make: order.car_info.brand.name, 
            model: order.car_info.model.name,
            year: order.car_info.initial_registration.substring(0,4), 
            transmission: this.mapGeartype(order.car_info.geartype.name) // this needs to be normalized
          },
        ],
      }
      window.dataLayer.push(pushObject);
    },
    finalizeOrder() {
      finalizeOrderCreate(this.order.token).then(r => {
        this.sendStatisticEvent('7');
        this.sendFinalStatistic(r);
        this.saveStepData(r, '7');
        this.scrollToTop();
      });
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    mapGeartype(type) {
      switch (type) {
        case 'Automatik':
          return 'Automatic';
        case 'Schaltgetriebe':
          return 'Manual';
        case 'Halbautomatik':
          return 'Automatic';
        default:
          return 'Other';
      }
    },
    mapBodytype(type) {
      switch (type) {
        case 'Limousine':
          return 'Sedan';
        case 'Cabriolet/Roadster':
          return 'Convertible';
        case 'Coupé/Sportwagen':
          return 'Coupe';
        case 'Kleinwagen':
          return 'Hatchback';
        case 'Geländewagen/SUV':
          return 'SUV';
        case 'Kombi':
          return 'Wagon';
        case 'Van':
          return 'Minivan';
        case 'Transporter':
          return 'Van';
        case 'sonstiges':
          return 'Other';
        default:
          return 'Other';
      }
    },
    mapFueltype(type) {
      switch (type) {
        case 'Benzin':
          return 'Gasoline';
        case 'Diesel':
          return 'Diesel';
        case 'Flüssiggas (LPG)':
          return 'Flex';
        case 'Elektro':
          return 'Electric';
        case 'Benzin/Elektro':
          return 'Hybrid';
        case 'Wasserstoff':
          return 'Flex';
        case 'Erdgas (CNG)':
          return 'Flex';
        case 'Benzin/Gas':
          return 'Flex';
        case 'Diesel/Elektro':
          return 'Hybrid';
        case 'andere':
          return 'Other';
        default:
          return 'Other';
      }
    }
  },
};
</script>

<style lang="scss">
.checkout-process-wrap {
  width: 100%;
  max-width: 69rem;
  margin: 0 auto;
}
.order-create {
  form {
    display: flex;
    flex-direction: column;
  }
}
</style>
